//提前加载图片
const preloadImages = () => {
    for(let i=1;i<38;i++){
        const img = new Image();
        img.src = `https://cdn.shopify.com/s/files/1/0584/6709/0582/files/gturbo_box3n_us_${i}.avif?v=1734680645`;
    }
    for(let i=1;i<50;i++){
        const img = new Image();
        img.src = `https://cdn.shopify.com/s/files/1/0584/6709/0582/files/gturbo_box4_us_${i}.avif?v=1734923066`;
    }
    for(let i=1;i<25;i++){
        const img = new Image();
        img.src = `https://cdn.shopify.com/s/files/1/0584/6709/0582/files/gturbo_box5n_us_${i}.avif?v=1735004030`;
    }
};
preloadImages()

if(window.innerWidth>750){
    var Wflag = true,box4_pinTop='top+=6%',box4_text1='-80rem',box4_text2='70rem',box4_y='-6rem',box4_s='1.2',box4_h='+=620%',
    box5_s1='top+=26% top+=6%',box5_s2='top+=6% top+=6%',box11V = 5,box3_s='top+=2% top'
}else{
    Wflag = false,box4_pinTop='top+=10%',box4_text1='-25rem',box4_text2='22rem',box4_y='0',box4_s='1',box4_h='+=520%',
    box5_s1='top+=20% top+=12%',box5_s2='top top+=12%',box11V = 1.5,box3_s='top top+=12%'
}

$(()=>{

    $('.box2_1 div img').click(function(){
        var element = $('.box2_video')[0]
        if(element.requestFullscreen){
            element.requestFullscreen()
        }
    })

    gsap.from('.box2_title',{
        y:'2rem',opacity:0,ease:'none',duration:0.5,
        scrollTrigger:{
            trigger:'.box2_title',
            start:'top bottom-=20%',
            end:'+=0',
            toggleActions:'play none none reverse',
            // markers:true
        }
    })
    
    gsap.from('.box2_items',{
        y:'2rem',opacity:0,ease:'none',duration:0.5,
        scrollTrigger:{
            trigger:'.box2_items',
            start:'top bottom-=20%',
            end:'+=0',
            toggleActions:'play none none reverse',
            // markers:true
        }
    })
    
    ScrollTrigger.create({
        trigger:'.box3',
        start:'top top+=8%',
        end:'+=200%',
        pin:true,
        scrub:1,
        // markers:true,
        animation:gsap.timeline()
            .to('.box3_img',{x:'0'})
            .to('.box3_icon1',{opacity:0,duration:0},'<25%')
            .to('.box3_icon2',{opacity:1,duration:0},'<')
            .to('.box3_title',{x:'0'},'-=50%')
    })
    
    ScrollTrigger.create({
        trigger:'.box3_1',
        start:box3_s,
        end:'+=200%',
        pin:true,
        // markers:true,
        onUpdate:(self)=>{
            let index = Math.floor(self.progress * 36);
            $('.box3_img1').attr('src', `https://cdn.shopify.com/s/files/1/0584/6709/0582/files/gturbo_box3n_us_${index+1}.avif?v=1734680645`)
        }
    })

    
    gsap.from('.box4_text1',{
        y:'2rem',opacity:0,ease:'none',duration:0.5,
        scrollTrigger:{
            trigger:'.box4_text1',
            start:'top bottom-=20%',
            end:'+=0',
            toggleActions:'play none none reverse',
            // markers:true
        }
    })
    
    gsap.from('.box4_text2',{
        y:'2rem',opacity:0,ease:'none',duration:0.5,
        scrollTrigger:{
            trigger:'.box4_text2',
            start:'top bottom-=20%',
            end:'+=0',
            toggleActions:'play none none reverse',
            // markers:true
        }
    })
    
    gsap.timeline({
        scrollTrigger:{
            trigger:'.box4',
            start:`top+=20% ${box4_pinTop}`,
            end:'+=80%',
            scrub:1
            // markers:true
        }
    })
    .to('.box4_text1',{x:box4_text1}) 
    .to('.box4_text2',{x:box4_text2},'<') 
    .to('.box4_img',{opacity:1},'<30%') 

    // 图片动画过程
    gsap.timeline({
        scrollTrigger:{
            trigger:'.box4',
            start:`top+=80% ${box4_pinTop}`,
            // 170% (总进程250%)
            end:'+=170%',
            // markers:true
            onUpdate:(self)=>{
                let index = Math.floor(self.progress * 48);
                $('.box4_img').attr('src', `https://cdn.shopify.com/s/files/1/0584/6709/0582/files/gturbo_box4_us_${index+1}.avif`)
            }
        }
    })

    // 第二阶段 切换过程
    gsap.timeline({
        scrollTrigger:{
            trigger:'.box4',
            start:`top+=220% ${box4_pinTop}`,
            end:'+=130%',
            scrub:1
            // markers:true
        }
    }).to('.box4_img',{y:box4_y,rotate:'15deg',scale:box4_s})
    .from('.box4_1',{opacity:0})
    .to('.box4_img',{opacity:0})
    .from('.box4_items1 .box4_items',{opacity:0},'<-80%')
    .from('.box4_items1 .box4_items div:nth-child(2)',{opacity:0},'<-80%')
    .from('.box4_title',{opacity:0})
    .from('.box4_items1 .box4_items div:nth-child(1)',{opacity:0},'<')
    .from('.box4_items1 .box4i_icon',{opacity:0},'<')
    .from('.box4_items1 .box4_text',{opacity:0},'<')

    // 芯子变化过程
    ScrollTrigger.create({
        trigger:'.box4',
        start:`top+=350% ${box4_pinTop}`,
        end:'+=250%',
        // markers:true,
        onUpdate:(self)=>{
            var index = self.progress.toFixed(3) * 100
            $('.box4_items1 .box4_items div:nth-child(2)').toggleClass('box4i1_active1',index>10)
            $('.box4_items1 .box4_items div:nth-child(2)').toggleClass('box4i1_active2',index>25)
            $('.box4_items1 .box4_items div:nth-child(2)').toggleClass('box4i1_active3',index>40)
            $('.box4_items2 .box4_items').toggleClass('box4_items2Show',index<55)
            $('.box4_items1 .box4_text').toggleClass('opacity0',index>55)
            $('.box4_items2 .box4_text').toggleClass('box4_items2Show',index<55)
            $('.box4_items2 .box4_items div:nth-child(2)').toggleClass('box4i2_active1',index>70)
            $('.box4_items2 .box4_items div:nth-child(2)').toggleClass('box4i2_active2',index>85)
        }
    })

    ScrollTrigger.create({
        trigger:'.box4',
        start:`top ${box4_pinTop}`,
        end:box4_h,
        pin:true,
        // markers:true
    })

    if(Wflag){
        gsap.timeline({
            scrollTrigger:{
                trigger:'.box7',
                start:`top+=10% ${box4_pinTop}`,
                end:'+=200%',
                scrub:true
                // markers:true
            }
        })
        .to('.box7_img img:nth-child(2)',{opacity:0})
    }else{
        gsap.timeline({
            scrollTrigger:{
                trigger:'.box7',
                start:`top+=10% ${box4_pinTop}`,
                end:'+=200%',
                scrub:true
                // markers:true
            }
        })
        .to('.box7_img img:nth-child(2)',{opacity:0})
    }
    

    ScrollTrigger.create({
        trigger:'.box7',
        start:`top ${box4_pinTop}`,
        end:'+=100%',
        pin:true,
        // markers:true
    })

    ScrollTrigger.create({
        trigger:'.box5',
        start:box5_s1,
        end:'+=150%',
        // markers:true,
        onUpdate:(self)=>{
            let index = Math.floor(self.progress * 23);
            $('.box5_img').attr('src', `https://cdn.shopify.com/s/files/1/0584/6709/0582/files/gturbo_box5n_us_${index+1}.avif?v=1735004030`)
            $('.box5_title').toggleClass('showup',index>20)
            $('.box5_info').toggleClass('showup',index>20)
        }
    })


    ScrollTrigger.create({
        trigger:'.box5',
        start:box5_s2,
        end:'+=220%',
        pin:true,
        // markers:true
    })

    // 呼吸灯
    ScrollTrigger.create({
        trigger:'.box6',
        start:`top+=20% ${box4_pinTop}`,
        end:'+=200%',
        // markers:true,
        onUpdate:(self)=>{
            var index = self.progress.toFixed(3) * 100
            if(index>2){
                $('.box6_item1 div').removeClass('box6_active')
                $('.box6_item1 div:nth-child(1)').addClass('box6_active')
            }else{
                $('.box6_item1 div').removeClass('box6_active')
            }
            if(index>22){
                $('.box6_item1 div').removeClass('box6_active')
                $('.box6_item1 div:nth-child(2)').addClass('box6_active')
            }
            if(index>44){
                $('.box6_item1 div').removeClass('box6_active')
                $('.box6_item1 div:nth-child(3)').addClass('box6_active')
            }
            if(index>66){
                $('.box6_item1 div').removeClass('box6_active')
                $('.box6_item1 div:nth-child(4)').addClass('box6_active')
            }
            if(index>88){
                $('.box6_item1 div').removeClass('box6_active')
                $('.box6_item1 div:nth-child(5)').addClass('box6_active')
            }
        }
    })

    gsap.timeline({
        scrollTrigger:{
            trigger:'.box6',
            start:`top+=230% ${box4_pinTop}`,
            end:'+=120%',
            scrub:1
            // markers:true
        }
    })
    .to('.box6_content1',{opacity:0})
    .from('.box6_content2',{opacity:0},'<')
    .to('.box6_item2 img',{x:0,y:0,opacity:1})
    .from('.box6_text',{y:'2rem',opacity:0})

    ScrollTrigger.create({
        trigger:'.box6',
        start:`top ${box4_pinTop}`,
        end:'+=370%',
        pin:true,
        // markers:true
    })



    if(Wflag){
        gsap.timeline({
            scrollTrigger:{
                trigger:'.box8',
                start:`top-=40% ${box4_pinTop}`,
                end:'+=180%',
                scrub:true
                // markers:true
            }
        }).from('.box8_img',{yPercent:'50',opacity:0})
        .from('.box8_img',{right:'10%'})
        .from('.box8_title',{opacity:0,y:'2rem'})
        .to('.box8_img img:nth-child(2)',{opacity:0,duration:0})
        .to('.box8_title div img:nth-child(2)',{opacity:0,duration:0})
    
        ScrollTrigger.create({
            trigger:'.box8',
            start:`top ${box4_pinTop}`,
            end:'+=180%',
            pin:true,
            // markers:true
        })
        
    }else{
        gsap.from('.box8_title',{
            y:'2rem',opacity:0,ease:'none',duration:0.5,
            scrollTrigger:{
                trigger:'.box8_title',
                start:'top bottom-=20%',
                end:'+=0',
                toggleActions:'play none none reverse',
                // markers:true
            }
        })

        gsap.timeline({
            scrollTrigger:{
                trigger:'.box8',
                start:`top+=10% ${box4_pinTop}`,
                end:'+=20%',
                toggleActions:'play none none reverse',
                // markers:true
            }
        })
        .to('.box8_img img:nth-child(2)',{opacity:0,duration:0})
        .to('.box8_title div img:nth-child(2)',{opacity:0,duration:0})

        ScrollTrigger.create({
            trigger:'.box8',
            start:`top ${box4_pinTop}`,
            end:'+=50%',
            pin:true,
            // markers:true
        })
        
    }


    gsap.from('.box9_title',{
        y:'2rem',opacity:0,ease:'none',duration:0.5,
        scrollTrigger:{
            trigger:'.box9_title',
            start:'top bottom-=20%',
            end:'+=0',
            toggleActions:'play none none reverse',
            // markers:true
        }
    })

    
    //box11
    var box11Swiper = new Swiper('.box11Swiper', {
        slidesPerView : box11V,
        centeredSlides: true,
        speed:1000,
        autoplay: {
            delay:1000,
            disableOnInteraction: false,
        },
    }) 
    box11Swiper.activeIndex = 2;
    box11Swiper.update()

    $('.box11_left').click(function(){
        if(box11Swiper.activeIndex>0){
            box11Swiper.slideTo(box11Swiper.activeIndex -1, 1000, false)
        }
    })

    $('.box11_right').click(function(){
        if(box11Swiper.activeIndex<15){
            box11Swiper.slideTo(box11Swiper.activeIndex +1, 1000, false)
        }
    })

    ScrollTrigger.create({
        trigger:'.box12',
        start:'top center',
        end:'+=0',
        // markers:true,
        onEnter: () => {
            if(window.innerWidth>750){
                $('.box12_img').css({transform:'translate(0,0)',opacity:1})
            }else{
                $('.box12_img').css({transform:'rotate(34deg) translate(0,0)',opacity:1})
            }
        },
        onLeaveBack: () => {
            if(window.innerWidth>750){
                $('.box12_img').css({transform:'translate(14rem,11rem)',opacity:0})
            }else{
                $('.box12_img').css({transform:'rotate(34deg) translate(10rem,1rem)',opacity:0})
            }
        }
    })
    
})
